<template>
  <div class="experiment-details" >
    <div
        class="c-data-content c-data-content__data c-data-content__experiment c-data-content--row"
        :class="[isWinner ? 'is-winner' : '']"
      >
        <div class="c-data-content__experiment--client">
            <h4></h4>
        </div>
        <div class="c-data-content__experiment--title">
            <p class="c-table__cel--very-small">{{ optionText }}</p>
            <h4>{{ title }}</h4>
        </div>
        <div class="c-data-content__experiment--graphs">
            <div class="c-data-content__graph">
                <div class="c-data-content__graph--labels">
                    <p class="c-table__graph--data">{{ $t('experiments.table.views')}}</p>
                    <p class="c-table__graph--data">{{ $t('experiments.table.clicks')}}</p>
                </div>
                <div class="c-data-content__graph--graphs">
                    <div class="c-table__graph--bar-views" :style="viewBar"></div>
                    <div class="c-table__graph--bar-clics" :style="clickBar"></div>
                </div>
                <div class="c-data-content__graph--values">
                    <p class="c-table__graph--data">{{ views }}</p>
                    <p class="c-table__graph--data">{{ clicks }}</p>
                </div>
            </div>
        </div>
        <div class="c-data-content__experiment--results">
            <p class="c-table__graph--data">CTR</p>
            <p class="c-table__graph--data-ctr">{{ ctrFormated }}%</p>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'ExperimentsDetails',
  props: {
    title: {
      type: String,
      required: true,
    },
    ctr: {
      type: Number,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
    views: {
      type: Number,
      required: true,
    },
    clicks: {
      type: Number,
      required: true,
    },
    isOriginal: {
      type: Boolean,
      required: true,
    },
    isWinner: {
      type: Boolean,
      required: true,
    },
    viewBar: {
      type: String,
      required: true,
    },
    clickBar: {
      type: String,
      required: true,
    },
  },
  computed: {
    optionText() {
      const text = this.$t('experiments.table.options', { option: (this.index + 1) })
      if (this.isOriginal) {
        return `${text} (original)`
      }

      return text
    },
    ctrFormated() {
      return this.ctr > 0 ? this.ctr.toFixed(2).replace(/\.00/, '') : this.ctr
    },
  },
}
</script>
